import { LibraryItem } from '../types';
import { TREES_API_BASE } from './config';

export async function uploadMedia(file: File): Promise<{ error?: string; item?: LibraryItem }> {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(`${TREES_API_BASE}/api/media/presigned`, {
      method: 'POST',
      body: formData,
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Failed to upload media');
    }

    return data;
  } catch (error) {
    console.error('Error uploading media:', error);
    return { error: error.message };
  }
}

export async function listMedia(): Promise<{ error?: string; items?: LibraryItem[] }> {
  try {
    const response = await fetch(`${TREES_API_BASE}/api/media`);
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Failed to list media');
    }
    return data;
  } catch (error) {
    console.error('Error listing media:', error);
    return { error: error.message };
  }
}

export async function deleteMedia(id: string): Promise<{ error?: string; success?: boolean }> {
  try {
    const response = await fetch(`${TREES_API_BASE}/api/media?id=${id}`, {
      method: 'DELETE',
    });

    let data;
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      data = await response.json();
    } else {
      // Handle non-JSON response
      const text = await response.text();
      data = { error: text };
    }

    if (!response.ok) {
      throw new Error(data.error || 'Failed to delete media');
    }
    return data;
  } catch (error) {
    console.error('Error deleting media:', error);
    return { error: error.message };
  }
}
